import { useStoreMap } from 'effector-react'
import { carVehicleCategoryModel } from '~/widgets/CarVehicleCategoryDrawer'
import { useMainTaxipark } from '~/widgets/MainTaxipark'
import { driverModel, RetryChecks } from '~/entities/Driver'
import { DriverStatusEnum } from '~/shared/config/enums'
import { Button } from '~/shared/ui/Buttons'
import { DriverStatus } from '../DriverStatus'
import { Title, Wrapper } from './styled'

export function EmptyRentalContract() {
  const hasOnlineRental = useMainTaxipark()?.hasOnlineRental

  const status = useStoreMap(driverModel.$driver, (driver) =>
    driver?.getStatus(),
  )

  const isShowRentalContractButton =
    status === DriverStatusEnum.APPROVED || status === DriverStatusEnum.FIRED

  return (
    <Wrapper>
      <Title data-testid='empty-car'>
        У вас еще нет <br /> арендованного авто
      </Title>

      {hasOnlineRental && isShowRentalContractButton && (
        <Button
          size='large'
          fullWidth
          onClick={() => carVehicleCategoryModel.openCarVehicleCategoryDrawer()}
        >
          Арендовать авто
        </Button>
      )}

      <DriverStatus />

      <RetryChecks />
    </Wrapper>
  )
}
